import {
    LOAD_PROFILE_SUCCESS,
    UPDATE_PROFILE_SUCCESS,
    UPDATE_PROFILE_REQUEST,
    UPDATE_PROFILE_ERROR
} from '../../actions'

const initialState = {
    profile: {
        email: '',
        information_collected: false,
        name: '',
        accepted_terms: false,
        contractor_details: {
            mobile_phone: '',
            business_phone: '',
            preferred_contact: 'Email',
            contractor_role: 'ElectricalContractor',
            business_entity: 'SoleProprietor',
            licence: '',
            bcse_accreditation_no: '',
            trading_name: '',
            abn: '',
        },
    },
    loaded: false,
    error: undefined,
    loading: false
}

const profile = (state = initialState, action) => {
    switch (action.type) {
        case LOAD_PROFILE_SUCCESS: {
            return {
                ...state,
                loaded: true,
                profile: {
                    ...action.payload,
                    contractor_details: {
                            ...initialState.profile.contractor_details,
                            ...action.payload.contractor_details
                        }
                }
            }
        }
        case UPDATE_PROFILE_REQUEST:
            return {
                ...state,
                loading: true
            }
        case UPDATE_PROFILE_SUCCESS:
            return {
                ...state,
                profile: {
                    ...action.payload
                    //...state.profile,
                    //information_collected: true,
                },
                loading: false
            }
        case UPDATE_PROFILE_ERROR:
            return {
                ...state,
                loading: false,
                error: {...action.error}
            }
        default:
            return state
    }
}

export default profile



// WEBPACK FOOTER //
// ./src/reducers/data/profile.js